<template>
  <s-modal
    :title="props.force ? 'Defina uma nova senha' : 'Alterar Senha'"
    v-model="visible"
    persistent
    :submit="handleSubmit"
    :actions="actions"
    v-if="visible"
    width="min(440px, 95vw)"
  >
    <!-- Troca obrigatória: a senha atual foi definida por quem cadastrou/redefiniu o usuário,
         então não é pedida aqui (a API também dispensa quando `alterar_senha` está ativo). -->
    <s-alert
      v-if="props.force"
      type="warning"
      density="dense"
      icon="mdiLockAlertOutline"
      message="Sua senha atual foi definida por um administrador. Escolha uma nova senha para continuar."
    />

    <s-card title="Nova senha" icon="mdiLockOutline" divider>
      <s-row>
        <s-col cols="24" v-if="!props.force">
          <s-input-password
            v-model="data.senha"
            label="Senha Atual"
            required
            density="comfortable"
            :disabled="loading"
          />
        </s-col>

        <s-col cols="24">
          <s-input-password
            v-model="data.novaSenha"
            label="Nova Senha"
            required
            density="comfortable"
            :disabled="loading"
          />
        </s-col>

        <s-col cols="24">
          <s-input-password
            v-model="data.confirmacao"
            label="Confirmar Senha"
            required
            density="comfortable"
            :disabled="loading"
          />
        </s-col>
      </s-row>
    </s-card>
  </s-modal>
</template>

<script setup lang="ts">
import { SModal, SRow, SCol, SAlert, SCard, type Action } from '@sieg-ad/componentes-vue';
import { useAuthStore } from '~/stores/auth';
import type { AuthPassword } from '~/types/schemas/autenticacao';

const props = defineProps<{
  modelValue: boolean;
  id: string | number | null;
  //? Troca obrigatória: esconde a senha atual e remove o Cancelar. O X do header ainda aparece
  //? e fecha sem checar `persistent`; quem segura o modal aberto é o setter no-op do v-model
  //? em layouts/default.vue.
  force?: boolean;
}>();

const emit = defineEmits(['update:modelValue']);
const authStore = useAuthStore();

const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const loading = ref<boolean>(false);

const setChangePassword = () => {
 return {
    senha: '',
    novaSenha: '',
    confirmacao: '',
  };
};

const data = ref<AuthPassword>(setChangePassword());

const resetCloseForm = () => {
  data.value = setChangePassword();
  visible.value = false;
  loading.value = false;
};

const actions = computed<Action[]>(() => [
  ...(props.force ? [] : [{
    name: 'Cancelar',
    type: 'error' as const,
    click: () => resetCloseForm(),
    loading: loading.value,
    icon: 'mdiClose' as const
  }]),
  {
    name: 'Salvar',
    type: 'success',
    submit: true,
    loading: loading.value,
    icon: 'mdiContentSave'
  },
])

const handleSubmit = async () => {

  if (loading.value) return;

  loading.value = true;

    try{

      if(data.value.novaSenha !== data.value.confirmacao) {
        warnToast("As senhas não coincidem!");
        loading.value = false;
        return;
      }

      const { success } = await authStore.changePassword(data.value)

      if(success) {
        //? Sai do estado de troca obrigatória sem esperar o próximo request refazer o X-User.
        if (authStore.user) authStore.user.alterar_senha = false;
        resetCloseForm();
        successToast('Senha atualizada com sucesso!');
      }
    } catch (error) {
      errorToast(apiMessage(error, 'Erro ao atualizar senha!'));
    }

  loading.value = false;
};

// LYFECYCLE

watch(visible, async (value) => {
  if (!value) {
    resetCloseForm();
  }
});
</script>
